import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { clearCustomRequest, customRequestApis, } from "../../../store/customRequest/actions";
import { useRequestState } from "./useRequestState";
var REQUEST_KEY = "putProductAvatar";
export var useUploadProductAvatar = function () {
    var dispatch = useDispatch();
    var _a = useRequestState(REQUEST_KEY), data = _a.data, error = _a.error;
    var uploadAvatar = function (_a) {
        var entity = _a.entity, id = _a.id, image = _a.image;
        var formData = new FormData();
        formData.append("file", image);
        dispatch(customRequestApis({
            requestKey: REQUEST_KEY,
            method: "PUT",
            path: "/asg/Api/V1/Avatars/Entities/".concat(entity, "/").concat(id, "/Avatars"),
            body: formData,
        }));
    };
    useEffect(function () {
        return function () {
            dispatch(clearCustomRequest(REQUEST_KEY));
        };
    }, []);
    return {
        uploadAvatar: uploadAvatar,
        avatarUploaded: data,
        error: error,
        clearAvatar: function () { return dispatch(clearCustomRequest(REQUEST_KEY)); },
    };
};
